<div class="container-fluid py-3 theme-showcase-page">
  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
    <div>
      <h3 class="mb-1">{{ 'i18n.domain.theme-showcase.title' | translate }}</h3>
      <p class="text-body-secondary mb-0">{{ 'i18n.domain.theme-showcase.subtitle' | translate }}</p>
    </div>
    <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2">
      @if (canChooseClient) {
        <app-theme-client-switcher
          [selectedClient]="selectedClient"
          [isClientThemeDirty]="isClientThemeDirty"
          (selectedClientChange)="onSelectedClientChange($event)">
        </app-theme-client-switcher>
      }

      <app-theme-mode-switcher
        [currentThemeMode$]="currentThemeMode$"
        (modeChange)="setTheme($event)">
      </app-theme-mode-switcher>
    </div>
  </div>

  <app-tenant-theme-editor
    [isSaving]="isSavingTenantTheme"
    [selectedClient]="selectedClient"
    (save)="onSave($event)"
    (dirtyChange)="onDirtyChange($event)">
  </app-tenant-theme-editor>

  <div class="card section-card mb-3">
    <div class="card-header d-flex align-items-center justify-content-between gap-2">
      <span>{{ 'i18n.domain.theme-showcase.components.title' | translate }}</span>
      <app-collapse-button [isExpanded]="isComponentsSectionExpanded" (toggleExpand)="toggleComponentsSection()"></app-collapse-button>
    </div>

    @if (isComponentsSectionExpanded) {
      <div class="card-body">
        <div class="row g-3">

          <div class="col-12 col-xl-6">
            <app-syncfusion-showcase></app-syncfusion-showcase>
          </div>

          <div class="col-12 col-xl-6">
            <app-bootstrap-showcase></app-bootstrap-showcase>
          </div>

          <div class="col-12">
            <app-validation-demo
              (validate)="onValidate()"
              (reset)="onResetValidation()">
            </app-validation-demo>
          </div>
        </div>
      </div>
    }
  </div>

  <app-theme-grid-showcase
    [isExpanded]="isGridSectionExpanded"
    (toggleExpand)="toggleGridSection()">
  </app-theme-grid-showcase>

  <app-theme-logo-preview
    [isExpanded]="isLogoSectionExpanded"
    [logoUrl]="tenantLogoPreviewUrl"
    [hasCustomLogo]="hasTenantLogoUrl"
    (toggleExpand)="toggleLogoSection()">
  </app-theme-logo-preview>
</div>
